import React, { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../redux/hooks';
import { selectUserInitialized } from '../../redux/slices/userSlice';
import CreateS3Upload from './CreateS3Upload';
import SpinnerComponent from '../../components/SpinnerComponent/SpinnerComponent';

const S3ToS3Upload = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isUserInitialized = useAppSelector(selectUserInitialized);
    const selectedContract = location.state?.selectedContract || null;

    const handleCloseCreateS3Upload = useCallback(() => {
        navigate('/data-upload');
    }, [navigate]);

    const handleTransferCreated = useCallback(() => {
        navigate('/data-upload');
    }, [navigate]);

    if (!isUserInitialized) {
        return (
            <SpinnerComponent
                isVisible={true}
                overlay={false}
                message="Loading..."
            />
        );
    }

    return (
        <CreateS3Upload
            onClose={handleCloseCreateS3Upload}
            onTransferCreated={handleTransferCreated}
            selectedContract={selectedContract}
        />
    );
};

export default S3ToS3Upload;
